const LandscapeImg = () => (
    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="449" height="122.061" viewBox="0 0 449 122.061">
        <path id="Path_1-3" data-name="Path 1" d="M428,0,168.036,101.061l-71.21-31.27L0,27.273V70.134H428Z" transform="translate(10.5 4.5)" fill="#17747c"/>
    </svg>
);

export default LandscapeImg;
